// extracted by mini-css-extract-plugin
module.exports = {"lessClutter":"MoreFocus_lessClutter__85b9q","reasons":"MoreFocus_reasons__BN2jj","reason":"MoreFocus_reason__byB24","focused":"MoreFocus_focused__rvauT"};